<div class="modal-content text-center">
    <div class="modal-header text-center">
        <button type="button" class="btn-close" (click)="cerrar()"></button>
    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/user-white.svg" alt="user">
        <h3 class="mt-2">{{escritorio.ejecutivo}}</h3>
        <hr class="w-75 mx-auto">
        <h3 class="">Datos de cliente</h3>
        <!-- <h6>Ingrese el RUT del cliente</h6> -->
    </div>
    <div class="modal-footer">
        <div class="row  mx-auto text-center">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <ng-container *ngIf="modo.nombre">
                    <div class="col-xl-12">
                        <p>Nombre cliente</p>
                    </div>
                    <div class="col-xl-10 offset-1 mb-2">
                        <div class="input-group  justify-content-center align-items-center">
                            <input type="text" class="form-control" id="nombreCliente" formControlName="nombreCliente" [ngClass]="{'is-invalid': formIsSubmitted && form.get('nombreCliente')!.errors}" class="w-75 text-center" />
                        </div>
                        <div *ngIf="form.controls['nombreCliente'].invalid && (form.controls['nombreCliente'].dirty || form.controls['nombreCliente'].touched || formIsSubmitted)">
                            <small class="text-danger">Debe ingresar un valor válido.</small>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="modo.rut">
                    <div class="col-xl-12">
                        <p>RUT Cliente</p>
                    </div>
                    <div class="col-xl-10 offset-1 mb-2 justify-content-center">
                        <div class="input-group  justify-content-center align-items-center">
                            <input type="text" class="form-control" id="rut" formControlName="rut" [readonly]="form.get('tipo')?.value == false" (keyup)="formatRut()" maxlength="12" [ngClass]="{'is-invalid':(formIsSubmitted == true && form.get('rut')!.invalid ) || (formIsSubmitted && (!validatedRut && !this.form.get('rut')?.errors))}" class="w-75 text-center" />
                        </div>
                        <div *ngIf="form.controls['rut'].invalid && (form.controls['rut'].dirty || form.controls['rut'].touched || formIsSubmitted)">
                            <small class="text-danger">Debe ingresar un valor válido.</small>
                        </div>
                        <div *ngIf="formIsSubmitted && !validatedRut && !this.form.get('rut')?.errors">
                            <small class="text-danger" *ngIf="rutRequerido">¡Por favor ingresa un RUT válido!</small>
                          </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="modo.telefono">
                    <div class="col-xl-12">
                        <p>Orden de compra</p>
                    </div>
                    <div class="col-xl-10 offset-1 mb-2 justify-content-center">
                        <div class="input-group  justify-content-center align-items-center">
                            <input type="text" class="form-control" id="fono" maxlength="10" (keypress)="validateInput($event)" formControlName="fono" [ngClass]="{'is-invalid':(formIsSubmitted == true && form.get('fono')!.invalid ) || (formIsSubmitted && !this.form.get('fono')?.errors)}" class="w-75 text-center" />
                        </div>
                       <div *ngIf="formIsSubmitted && form.controls['fono'].invalid">
                            <small class="text-danger" *ngIf="form.controls['fono'].errors?.['required']">
                                Debe ingresar un valor.
                            </small>
                            <small class="text-danger" *ngIf="form.controls['fono'].errors?.['minlength'] || form.controls['fono'].errors?.['maxlength']">
                                Debe tener entre 8 y 10 caracteres.
                            </small>
                            <br>
                            <small class="text-danger" *ngIf="form.controls['fono'].errors?.['pattern']">
                                Solo se permiten caracteres alfanuméricos.
                            </small>
                        </div>
                    </div>
                </ng-container>
                
                <div class="row mx-auto modal-datos-usuario-botonera">
                    <div class="col-xl-12 text-center">
                        <!-- <h3>¿Desea sobreescribir los datos del cliente?</h3> -->
                       <div class="mt-3 d-flex">
                        <!-- <button type="button" class="btn-color-2 me-4" (click)="cerrar()">Sin RUT</button> -->
                        <button type="button" class="btn-color mx-auto" type="submit">Guardar</button>
                       </div>
                    </div>
                    <div class="col-xl-12 text-center">
                        <a type="button" (click)="cerrar()">Volver a aplicación</a>
                       </div>
                </div>
            </form>
           
        </div>
    </div>
</div>
